module.exports = __webpack_public_path__ + "img/no-attach-files-background.eb4c213b.png";